export const FETCH_DASHBOARD_DATA_SUCCESS =
  'DASHBOARD::FETCH_DASHBOARD_DATA_SUCCESS';
export const FETCH_DASHBOARD_DATA_ERROR =
  'DASHBOARD::FETCH_DASHBOARD_DATA_ERROR';

export const RESET = 'DASHBOARD::RESET';
